// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-input[data-v-6cd498d7] {\n  border: 1px solid blue;\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
